// One-time UX flags for the resume-tailoring flow.
//
// Every access is guarded: Safari's private mode throws on localStorage, and a
// coaching nicety must never take the editor or the preview drawer down with
// it. Reads fail CLOSED (report "already seen") so a browser that can't
// remember a dismissal shows the resume instead of a modal it would re-show on
// every single open.

const REBUILD_EXPLAINER_SEEN = 'jb.resumeRebuildExplainerSeen';

/**
 * True once the user has been shown the first-run "why your resume looks
 * different" explainer — the one-time answer to the question a rebuilt resume
 * provokes before any editing question occurs to them.
 */
export const hasSeenRebuildExplainer = (): boolean => {
  try {
    return localStorage.getItem(REBUILD_EXPLAINER_SEEN) === 'true';
  } catch (error) {
    console.warn('resumeTailorStorage: could not read the explainer flag', error);
    return true;
  }
};

/** Retires the explainer everywhere — the flag is shared by the tailor editor
 *  and the read-only tailored preview drawer, so whichever surface a user meets
 *  their rebuilt resume on first is the one that explains it, once. */
export const markRebuildExplainerSeen = (): void => {
  try {
    localStorage.setItem(REBUILD_EXPLAINER_SEEN, 'true');
  } catch (error) {
    console.warn(
      'resumeTailorStorage: could not persist the explainer flag',
      error
    );
  }
};
